import {
  MAIN_ROUTES,
} from '@/router/components';
import { BackgroundColors } from '@/@types/types';

export default {
  path: 'sources',
  meta: {
    requiresAuth: true,
    breadCrumb: 'app.navigation-drawer.sources',
  },
  component: MAIN_ROUTES.INTEGRATIONS,
  children: [{
    path: '',
    name: 'sources',
    meta: {
      requiresAuth: true,
      hideBreadCrumb: true,
      breadCrumb: 'sources.search',
      background: BackgroundColors.SECONDARY,
      preventScrollTop: true,
    },
    component: () => import('@/views/FrontendNextRouteView.vue'),
  }, {
    path: ':id',
    name: 'sources.source',
    meta: {
      requiresAuth: true,
      breadCrumb: 'sources.search',
      breadCrumbFromParamName: true,
      background: BackgroundColors.SECONDARY,
      preventScrollTop: true,
    },
    props: true,
    component: () => import('@/views/FrontendNextRouteView.vue'),
  }, {
    path: 'source/add',
    name: 'sources.source.new',
    meta: {
      requiresAuth: true,
      breadCrumb: 'sources.new_source',
      breadCrumbFromParamName: true,
      background: BackgroundColors.SECONDARY,

    },
    props: true,
    component: () => import('@/views/FrontendNextRouteView.vue'),
  }, {
    path: 'source/:id/edit',
    name: 'sources.source.edit',
    meta: {
      requiresAuth: true,
      breadCrumb: 'sources.edit_source',
      breadCrumbFromParamName: false,
      background: BackgroundColors.SECONDARY,

    },
    props: true,
    component: () => import('@/views/FrontendNextRouteView.vue'),
  }],
};
